export default {
  refurbishedBy: {
    id: 'product_page_reassurance_item_refurbished_by',
    defaultMessage: 'Refurbished by {sellerName}',
  },
  viewComplianceInfo: {
    id: 'product_page_reassurance_item_view_compliance_info',
    defaultMessage: 'View compliance info',
  },
  reviewsCount: {
    id: 'product_page_reassurance_item_seller_reviews_count',
    defaultMessage: '({count, plural, one {# review} other {# reviews}})',
  },
} as const
